import DataTable from './DataTable';

export default DataTable;


// WEBPACK FOOTER //
// ./src/Components/DataTable/index.tsx